import {useSelector} from "react-redux";
import Base from "../../modules/Base";
import Login from '../../modules/auth/Login';
import {checkPermission} from "../routes/RouteValidator";
import {useEffect, useState} from "react";

const AuthMiddleware = ({children}: { children: any }) => {
    const user = useSelector((state: any) => state.auth);
    const company = useSelector((state: any) => state.company);
    const [allowed, setAllowed] = useState(false);
    useEffect(() => {
        checkPermission(user, company) ? setAllowed(true) : setAllowed(false)
    }, [window.location.pathname]);


    return user.token != null && allowed ?  <Base children={children}/> : <Login/>;
}

export default AuthMiddleware;
